import React from "react";
import { Box, Typography } from "@mui/material";
import ClientRelationshipBadge from "../Chat/ClientRelationshipBadge";
import { getClientListRelationshipProps } from "../../utils/clientRelationships";

/** Nome + e-mail da busca de cliente, com o mesmo chip de relacionamento do chat. */
export default function ClientSearchOption({
  client,
  primary,
  secondary,
  fallbackPrimary = "Sem nome",
}) {
  const { count, hint } = getClientListRelationshipProps(client);
  const name = primary || fallbackPrimary;

  return (
    <Box sx={{ minWidth: 0, width: "100%" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}>
        <Typography variant="body2" noWrap sx={{ minWidth: 0 }}>
          {name}
        </Typography>
        {count > 0 ? (
          <ClientRelationshipBadge count={count} hint={hint} compact />
        ) : null}
      </Box>
      {secondary ? (
        <Typography variant="caption" color="text.secondary" display="block">
          {secondary}
        </Typography>
      ) : null}
    </Box>
  );
}
